/**
 * The message to show for a failed request.
 *
 * Shared rather than copied per page: `normalizeError` already turns a transport
 * failure into a `{ code, message }` the UI can read, and every page then wants
 * the same last step — that message, or a plain sentence when there isn't one.
 * Three private copies of this had begun to accumulate.
 *
 * The fallback is deliberately not the raw error. A stringified
 * `FetchBaseQueryError` in front of an operator is noise they cannot act on, and
 * it tends to be the one part of an interface that ends up in a screenshot.
 */
export function messageOf(error: unknown): string {
  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim() !== '') return message;
  }
  return 'That did not work. Please try again.';
}
